import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_HOST } from "environments/environment";

/**
 * Reprezentacja powiązanego konta zwracana przez backend (bez link tokena).
 */
export interface ConnectedAccountDto {
    _id: string;
    linkedUserId: string;
    email: string;
    companyName: string | null;
    createdAt: string;
    lastUsedAt: string | null;
    expiresAt: string;
}

@Injectable({ providedIn: 'root' })
export class ConnectedAccountsApiService {

    constructor(private http: HttpClient) { }

    public list() {
        return this.http.get<any>(API_HOST + 'connected-accounts');
    }

    public attach(emailAddress: string, password: string) {
        return this.http.post<any>(API_HOST + 'connected-accounts/attach', { emailAddress, password });
    }

    public verifyAttach2fa(tempToken: string, code: string) {
        return this.http.post<any>(API_HOST + 'connected-accounts/attach/verify-2fa', { tempToken, code });
    }

    public unlink(linkId: string) {
        return this.http.delete<any>(API_HOST + `connected-accounts/${linkId}`);
    }

    public switchTo(linkId: string, deviceMeta: { browser?: string; deviceName?: string; platform?: string } = {}) {
        return this.http.post<any>(API_HOST + `connected-accounts/${linkId}/switch`, deviceMeta);
    }
}
